import {Component, ElementRef, HostBinding, ViewChild} from "@angular/core";

@Component({
    selector: "fui-content-section",
    styleUrls: ["./content-section.component.scss"],
    templateUrl: "./content-section.component.html"
})
export class FUIContentSectionComponent {
    private _content: ElementRef;
    @HostBinding("class.filled") public filled: boolean;

    @ViewChild("content")
    set content(value: ElementRef) {
        this._content = value;
        setTimeout(() => this.filled = this._content && this._content.nativeElement && this._content.nativeElement.children.length);
    }

    get content(): ElementRef {
        return this._content;
    }
}